<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <teikejas-rengiami-search
      :loading="loading"
      @search="searchTeikejasRengiami"
    />

    <v-data-table
      class="mb-4"
      :loading="loading"
      :headers="filteredHeaders"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.zug_busena`]="{ item }">
        <el-hipoteka-busena :busena="item.zug_busena" />
      </template>
      <template #[`item.pranesimas`]="{ item }">
        <div class="nowrap">
          <el-byla v-for="byla in item.bylos" :key="byla.byl_id" :byla="byla" />
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action :item="item" @deleteItem="checkItem(item)" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template slot="loading">
        kraunasi
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-delete
      title="Šalinti dokumentą?"
      :text="modalDeleteText"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />

    <modal-confirm
      title="Šalinti dokumentą?"
      :text="confirmText"
      :show-save="false"
      v-model="showConfirm"
    />
  </v-container>
</template>

<script>
import HipotekaMap from '../hipoteka/hipotekaMap'
import math from '../../mixins/math'
import TeikejasRengiamiSearch from './TeikejasRengiamiSearch'
import ModalDelete from '../modals/ModalDelete'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'TeikejasRengiami',
  components: {
    TeikejasRengiamiSearch,
    ModalDelete,
    ModalConfirm,
  },
  mixins: [math],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      pranesimai: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,

      showDelete: false,
      modalDeleteText: '',
      modalDeleteItem: null,

      showConfirm: false,
      confirmText: '',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Rengimo vieta',
          align: 'start',
          value: 'vieta',
        },
        {
          text: 'Pranešimo būsena',
          align: 'start',
          value: 'zug_busena',
        },
        {
          text: 'Dokumento Nr.',
          align: 'start',
          value: 'obj_dokumento_numeris',
        },
        {
          text: 'Dokumento ID',
          align: 'start',
          value: 'obj_id',
        },
        {
          text: 'Pranešimo rūšis',
          align: 'start',
          value: 'hipotekaTipas',
        },
        {
          text: 'Naudotojas',
          align: 'start',
          value: 'sukure',
        },
        {
          text: 'Pradžios data',
          align: 'start',
          value: 'sukurimo_data',
        },
        {
          text: 'Identifikacinis kodas',
          align: 'start',
          value: 'obj_identifikavimo_kodas',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filterItemList() {
      return this.pranesimai.map(item => {
        item.vieta = item.sistema === 1 ? 'Darbo vieta' : 'Savitarna'

        item.hipotekaTipas = HipotekaMap['hipotekaTipas'][item.obj_tipas]
          ? HipotekaMap['hipotekaTipas'][item.obj_tipas].title
          : item.obj_tipas

        let hipoteka_veiksmas = ''
        if (item.obj_veiksmas === 1) {
          hipoteka_veiksmas = ' (sudarymas)'
        }
        if (item.obj_veiksmas === 2) {
          hipoteka_veiksmas = ' (teikimas)'
        }
        if (item.obj_veiksmas === 3) {
          hipoteka_veiksmas = ' (perleidimas)'
        }
        item.hipotekaTipas += hipoteka_veiksmas

        item.canDelete = item.galima_salinti

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    //this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`pranesimas/dt-rengiami`, data)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchTeikejasRengiami(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
    checkItem(item) {
      this.loading = true

      this.$axios
        .get(`objektas/${item.obj_id}/dt-rengiamas/check`)
        .then(res => {
          this.deleteItem(item)
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.confirmText = err.response.data.message
            this.showConfirm = true
            return
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteItem(item) {
      this.modalDeleteText = `Ar tikrai norite pašalintą pradėtą rengti pranešimą <b>${item.hipotekaTipas}</b>, kurio IDK <b>${item.obj_identifikavimo_kodas}</b>?`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`objektas/${item.obj_id}/dt-rengiamas`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
